import { OkapiError } from "@/lib/openapi";
import { showToast } from "@/lib/toasts";

const okapiErrorMessage = (
  err: unknown,
  fallback = "Please try again later."
): string => {
  return err instanceof OkapiError ? err.userFacingMessage : fallback;
};

export const showOkapiErrorToast = (
  err: unknown,
  title: string,
  fallbackMessage = "Please try again later."
): void => {
  showToast({
    type: "error",
    title,
    message: okapiErrorMessage(err, fallbackMessage),
  });
};
